export default __webpack_public_path__ + "static/media/opensans-bold-webfont.aede7371.woff";